import { Record, List, OrderedMap, Map } from "immutable";
import { STATE_STATUS, BASE_INBOX_COLS as INBOX_CASES_COLS } from "constants";

export class StagePermissionRecord extends Record({
    id: null,
    ids: [],
    key: null,
    stage_name: null,
    can_proceed: null,
    can_reject: null,
    can_refer: null,
    can_edit: null,
    can_hold: null,
    is_mandatory_allocation: null,
    columns: null
}) {
    getEditableColumns() {
        return this.can_edit ? this.can_edit.toArray() : [];
    }
    getStageColumns() {
        const colsMap = this.columns
            .toMap()
            .mapEntries(([, value]) => {
                const key = Object.keys(value)[0];
                return [key, value[key]];
            });
        const editableCols = this.getEditableColumns();
        return INBOX_CASES_COLS
            .filter(_ =>colsMap.get(_.permissionName || _.key))
            .map(_ => {
                if (editableCols.includes(_.permissionName || _.key)) {
                    /* eslint-disable no-unused-vars */
                    return {
                        ..._,
                        sortIndex: colsMap.get(_.key),
                        editable: true,
                        onCellGenerator: handleSave => record => ({
                            record,
                            editable: true,
                            dataIndex: _.dataIndex,
                            title: _.title,
                            handleSave
                        })
                    };
                }
                return { ..._, sortIndex: colsMap.get(_.key) };
            }).sort((a, b) => {
                if(a.sortIndex > b.sortIndex) {
                    return 1;
                } else if(a.sortIndex < b.sortIndex) {
                    return -1;
                } else if(a.sortIndex === b.sortIndex) {
                    return 0;
                }
            });
    }
    getShortInfo() {
        return {
            name: this.stage_name,
            id: this.id,
            key: this.key
        };
    }
}

export class StagePermissionsListRecord extends Record({
    data: new List([]),
    status: STATE_STATUS.UNFETCHED
}) {
    getStages() {
        return this.data.map(_ => _.stage_name);
    }
    getSize() {
        return this.data.size;
    }
    isDataFetched() {
        return this.status === STATE_STATUS.FETCHED;
    }
    getDefaultTab() {
        return this.data.size
            ? this.data
                .filter(_ => !_.key)
                .first()
                .getShortInfo()
            : null;
    }
    getStageId(stageName) {
        return (this.data.find(_ => _.stage_name === stageName) || {}).id;
    }
    getStageName(stageId) {
        return (this.data.find(_ => _.id === stageId) || {}).stage_name;
    }
    getStageColumns(stageName) {
        return stageName
            ? (this.data.find(_ => _.stage_name === stageName) || {}).getStageColumns()
            : new OrderedMap({});
    }
    getActionPermissionMap(stageName) {
        const stage = this.data.find(_ => _.stage_name === stageName);

        return new Map({
            PROCEED: stage && stage.can_proceed && stage.can_proceed.size > 0,
            REFER: stage && stage.can_refer && stage.can_refer.size > 0,
            REJECT: stage && stage.can_reject,
            HOLD: stage && stage.can_hold            
            // APPROVE: stage.can_approve
        });
    }
}

export class UserRecord extends Record({
    id: null,
    title: null,
    first_name: null,
    middle_name: null,
    last_name: null,
    gender: null,
    email: null,
    mobile_number: null,
    designation: null,
    groups: null,
    relationship_with_company: null,
    is_staff: null,
    is_notes_email_notification_required: null,
    expiry_date: null,
    profile_icon: null,
    stage_admin: []
}) {
    get full_name() {
        return `${this.first_name}${
            this.middle_name ? " " + this.middle_name : ""
        } ${this.last_name}`;
    }
    isUserStageAdmin(stageId) {
        return (
            this.stage_admin &&
            this.stage_admin.length > 0 &&
            !!this.stage_admin.find(_ => _ === stageId)
        );
    }
}
